var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18V5H9C8.44772 5 8 4.55228 8 4C8 3.44772 8.44772 3 9 3H19C19.5523 3 20 3.44772 20 4V18C20 18.7957 19.6837 19.5585 19.1211 20.1211C18.5585 20.6837 17.7957 21 17 21H9C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19H17C17.2652 19 17.5195 18.8946 17.707 18.707C17.8946 18.5195 18 18.2652 18 18ZM11.293 8.29297C11.6591 7.92685 12.2381 7.90426 12.6309 8.22461L12.707 8.29297L15.707 11.293C16.0976 11.6835 16.0976 12.3165 15.707 12.707L12.707 15.707C12.3165 16.0976 11.6835 16.0976 11.293 15.707C10.9024 15.3165 10.9024 14.6835 11.293 14.293L12.5859 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H12.5859L11.293 9.70703L11.2246 9.63086C10.9043 9.23809 10.9269 8.65908 11.293 8.29297Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.1767c70e51a8ee6728cf543a80e55efe.svg";
export { ForwardRef as ReactComponent };